module.exports = " <div class=\"row row--map\">\r\n     <div class=\"map col-12\">\r\n         <div id=\"map\"></div>\r\n     </div>\r\n </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mapa/mapa.component.html
// module id = ./src/app/mapa/mapa.component.html
// module chunks = main